import Switch from '@components/v2/form/Switch/Switch';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { SatisfactionSurveySettingsSectionProps } from '../satisfactionSurveySettings.types';

const SatisfactionSurveyEnabledToggle = ({
  settings,
  isDisabled,
  onChange,
}: SatisfactionSurveySettingsSectionProps) => {
  const { translate } = useTranslation();

  const canEnable = !!settings.url;

  return (
    <Switch
      checked={settings.enabled}
      disabled={isDisabled || !canEnable}
      label={translate(LangEnum.SATISFACTION_SURVEY_SETTINGS_ENABLED_LABEL)}
      name="enabled"
      size="medium"
      sx={{ ml: 0 }}
      onChange={(event) => onChange({ enabled: event.target.checked })}
    />
  );
};

export default SatisfactionSurveyEnabledToggle;
